import React from 'react'
import Visually from '../../assets/icons/visually.svg'
import Application from '../../assets/icons/application.svg'
import Admission from '../../assets/icons/admission.svg'
import DetailsCard from '../DetailsCard'
import title_icon1 from '../../assets/icons/appIcon1.svg'
import title_icon2 from '../../assets/icons/appIcon2.svg'
import title_icon3 from '../../assets/icons/appIcon3.svg'
import visually1 from '../../assets/images/processes/visually1.png'
import application1 from '../../assets/images/processes/application1.png'
import application2 from '../../assets/images/processes/application2.png'
import application3 from '../../assets/images/processes/application3.png'
import application4 from '../../assets/images/processes/application4.png'
import admission1 from '../../assets/images/processes/admission1.png'
import admission2 from '../../assets/images/processes/admission2.png'
import admission3 from '../../assets/images/processes/admission3.png'
import admission4 from '../../assets/images/processes/admission4.png'
import admission5 from '../../assets/images/processes/admission5.png'




const ApplicationProcesses = ({setData, setModal}) => {

    const application = [
        {
          id: 1,
          name: 'Visually Impaired',
          icon: Visually,
          alt: 'visual_icon',
          title: 'Visually impaired',
          title_icon: title_icon1,
          images : [
            {
              id: 1,
              img: visually1,
            },
          ],
          img_alt : 'entry_image'
        },
        {
          id: 2,
          name: 'Application Instructions',
          icon: Application,
          alt: 'Application_icon',
          title: 'Application instructions',
          title_icon: title_icon2,
          images : [
            {
              id: 1,
              img: application1,
            },
            {
              id: 2,
              img: application2,
            },
            {
              id: 3,
              img: application3,
            },
            {
              id: 4,
              img: application4,
            },
          ],
          img_alt : 'entry_image'
        },
        {
          id: 3,
          name: 'Admission Quota',
          icon: Admission,
          alt: 'Admission_icon',
          title: 'Admission quota',
          title_icon: title_icon3,
          images : [
            {
              id: 1,
              img: admission1,
            },
            {
              id: 2,
              img: admission2,
            },
            {
              id: 3,
              img: admission3,
            },
            {
              id: 4,
              img: admission4,
            },
            {
              id: 5,
              img: admission5,
            },
          ],
          img_alt : 'entry_image'
        },
      ]


      const handleModal = (item) => {
        setModal(item)
        setData(item)
      }

      
  return (
    <div className='flex items-center justify-between w-full flex-wrap mt-11 md:justify-start lg:relative'>
            {application.map((item) => {
              return(
                <DetailsCard onClick={()=>handleModal(item)} key={item.id} data={item} index={item.id} />
              )
            })}

    </div>
  )
}

export default ApplicationProcesses
